<template>
  <tr
    :class="{
      'table__tr--background': validateIsInserted(),
      'table__tr--red': invoice.ESTAT === 'VENCIDO',
    }"
  >
    <!-- Document Number -->
    <td>
      <div class="d-flex align-items-center justify-content-center">
        <v-checkbox
          v-if="validateInvoiceWell()"
          :disabled="invoice.isApplied === 1"
          class="mt-0"
          hide-details
          :input-value="selected.BELNR === invoice.BELNR"
          @change="toggleSelection"
        />
        {{ invoice.BELNR }}
        <special-order-type-icon :order="invoice.AUART" />
      </div>
    </td>
    <!-- Purchase Order -->
    <td>
      {{ !validateIsInserted() ? invoice.ORDCOM : '-' }}
    </td>
    <!-- Downloads -->
    <td>
      <div class="d-flex justify-content-center">
        <div class="d-flex align-items-start download-icons-container">
          <download-invoice-tooltip :invoice-id="invoice.BELNR" :type="1" />

          <download-invoice-tooltip :invoice-id="invoice.BELNR" :type="2" />

          <template v-if="!invoice.inserted">
            <download-invoice-tooltip
              v-if="invoice.ACUSEDOC !== ''"
              :invoice-id="invoice.BELNR"
              :type="3"
            />

            <download-invoice-tooltip
              v-if="invoice.ACUSEDOC64 == '1' && invoice.ACUSEDOC == ''"
              :invoice-id="invoice.BELNR"
              :type="4"
            />

            <download-invoice-tooltip
              v-if="invoice.ACUSEFAC64 == '1' && invoice.ACUSEDOC == ''"
              :invoice-id="invoice.BELNR"
              :type="5"
            />
          </template>
        </div>
      </div>
    </td>
    <!-- Document Type -->
    <td>
      <div class="d-flex align-items-center">
        <div v-if="!validateIsInserted()" class="icon-toggle-container">
          <v-icon
            v-if="invoice.DETFAC !== undefined && invoice.DETFAC.length > 0"
            small
            color="#5600e8"
            @click="$emit('actionButton')"
          >
            {{ invoice.isOpen ? 'mdi-minus-circle' : 'mdi-plus-circle' }}
          </v-icon>
        </div>
        <span class="w-100">{{ invoice.TIPO }}</span>
        <div class="badge-container">
          <span v-if="invoice.AUGRU" class="badge rounded-pill badge-augru">{{
            invoice.AUGRU
          }}</span>
        </div>
      </div>
    </td>
    <!-- Document Date -->
    <td>{{ invoice.BUDAT }}</td>
    <!-- Expiration date -->
    <td>{{ !validateIsInserted() ? invoice.FVENC : '-' }}</td>
    <!-- Days Expired -->
    <td>{{ !validateIsInserted() ? invoice.DVENC : '-' }}</td>
    <!-- Amount -->
    <td>${{ invoice.DMBTR | formatCurrency }}</td>
    <!-- Early Payment Discount -->
    <td>
      <span
        v-if="
          validateInvoiceWell() && invoice.DPP > 0 && invoice.isApplied !== 1
        "
        >3%</span
      >
    </td>
  </tr>
</template>

<script>
  import DownloadInvoiceTooltip from '@/components/DownloadInvoiceTooltip.vue';
  import axios from '@/plugins/axios';
  import SpecialOrderTypeIcon from '@/components/SpecialOrderTypeIcon.vue';

  export default {
    components: { DownloadInvoiceTooltip, SpecialOrderTypeIcon },
    props: {
      invoice: {
        type: Object,
        required: true,
      },
      selected: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        image: '',
      };
    },
    methods: {
      validateIsInserted() {
        return this.invoice.inserted;
      },
      async getPDFXMLInvoice(invoice, type) {
        try {
          const response = await axios.post('/InvoicePDFXML', {
            invoice: invoice,
            type: type,
          });

          this.openDocument(response.data);
        } catch (error) {
          this.$toast.error('Ocurrió un error al abrir el documento');
        }
      },
      async getAcuseInvoice(invoice, type) {
        try {
          const { data } = await axios.get('/invoiceAcuse', {
            params: { invoice },
          });
          const acuse = data?.data;

          const imageMap = {
            3: acuse?.ACUSEDOC,
            4: acuse?.ACUSEDOC64,
            5: acuse?.ACUSEFAC64,
          };

          const image = imageMap[type] || '';
          this.openDocument(image);
        } catch (error) {
          this.$toast.error('Ocurrió un error al abrir el documento');
        }
      },
      openDocument(document) {
        if (document) {
          window.open(document, '_blank');
        } else {
          this.$toast.warning(
            'No se encontró ningún documento disponible para esta factura.'
          );
        }
      },
      formatCurrency(value) {
        return this.$options.filters.formatCurrency(value);
      },
      toggleSelection() {
        this.$emit(
          'update:selected',
          this.selected.BELNR === this.invoice.BELNR ? {} : this.invoice
        );
      },
      validateInvoiceWell() {
        return this.invoice.TIPO === 'FACTURA' && this.invoice.inserted;
      },
    },
  };
</script>

<style scoped>
  .table__tr--red {
    color: red;
  }
  .table__tr--background td {
    background: #f2f2f2;
  }
  .download-icons-container {
    width: 70px;
  }
  .icon-toggle-container {
    min-width: 30px;
  }
  .badge-container {
    min-width: 32px;
  }
  .badge-augru {
    background: #306b75;
  }
</style>
